// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1Swva","title":"styles_title__1rd77","content":"styles_content__3RVEr","multi-column":"styles_multi-column__3xQBj","multiColumn":"styles_multi-column__3xQBj"};